import { render, staticRenderFns } from "./VisitorPresentation.vue?vue&type=template&id=70e638b0&scoped=true"
import script from "./VisitorPresentation.vue?vue&type=script&lang=js"
export * from "./VisitorPresentation.vue?vue&type=script&lang=js"
import style0 from "./VisitorPresentation.vue?vue&type=style&index=0&id=70e638b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e638b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e638b0')) {
      api.createRecord('70e638b0', component.options)
    } else {
      api.reload('70e638b0', component.options)
    }
    module.hot.accept("./VisitorPresentation.vue?vue&type=template&id=70e638b0&scoped=true", function () {
      api.rerender('70e638b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/VisitorPresentation.vue"
export default component.exports